module.exports = __webpack_public_path__ + "static/media/pennzoil.7cad3865.png";